"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var RenderProp = _interopRequireWildcard(require("../utils/propTypes/renderProp"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _Color = require("../core/Color");

var _colors = require("HubStyleTokens/colors");

var _UIDialogCloseButton = _interopRequireDefault(require("../dialog/UIDialogCloseButton"));

var _UIDialogFooter = _interopRequireDefault(require("../dialog/UIDialogFooter"));

var _UIImage = _interopRequireDefault(require("../image/UIImage"));

var _UIModal = _interopRequireDefault(require("../dialog/UIModal"));

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  && {\n    height: 100%;\n    margin: auto;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  && {\n    background-color: ", ";\n    color: inherit;\n    padding-left: ", ";\n    padding-right: ", ";\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  bottom: 0;\n  color: inherit;\n  position: absolute;\n  width: 100%;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  && {\n    display: block;\n    height: 100%; /* needed to account for overly tall images */\n    padding: ", ";\n    word-wrap: break-word;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var LIGHTBOX_PADDING = '70px';

var StyledModalBody = _styledComponents.default.div.withConfig({
  displayName: "UILightbox__StyledModalBody",
  componentId: "uvcnis-0"
})(_templateObject(), LIGHTBOX_PADDING);

var FooterWrapper = _styledComponents.default.div.withConfig({
  displayName: "UILightbox__FooterWrapper",
  componentId: "uvcnis-1"
})(_templateObject2());

var LightboxFooter = (0, _styledComponents.default)(_UIDialogFooter.default).withConfig({
  displayName: "UILightbox__LightboxFooter",
  componentId: "uvcnis-2"
})(_templateObject3(), (0, _Color.rgba)(_colors.PANTERA, 0.89), LIGHTBOX_PADDING, LIGHTBOX_PADDING);
var LightboxImage = (0, _styledComponents.default)(_UIImage.default).withConfig({
  displayName: "UILightbox__LightboxImage",
  componentId: "uvcnis-3"
})(_templateObject4());

var DefaultFooterComponent = function DefaultFooterComponent(props) {
  var children = props.children;
  return _react.default.createElement(LightboxFooter, {
    align: "between",
    layout: "default"
  }, children);
};

var UILightbox = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(UILightbox, _Component);

  function UILightbox() {
    (0, _classCallCheck2.default)(this, UILightbox);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UILightbox).apply(this, arguments));
  }

  (0, _createClass2.default)(UILightbox, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          closeable = _this$props.closeable,
          FooterComponent = _this$props.FooterComponent,
          imageAlt = _this$props.imageAlt,
          ImageComponent = _this$props.ImageComponent,
          imageSrc = _this$props.imageSrc,
          onClose = _this$props.onClose,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "closeable", "FooterComponent", "imageAlt", "ImageComponent", "imageSrc", "onClose"]);

      if (process.env.NODE_ENV !== 'production') {
        if (imageSrc && !imageAlt) {
          _devLogger.default.warn({
            message: 'UILightbox: for better accessibility, please include a description ' + 'of the image in the `imageAlt` prop .',
            key: 'UILightbox: missing imageAlt prop'
          });
        }
      }

      return _react.default.createElement(_UIModal.default, (0, _extends2.default)({}, rest, {
        use: "lightbox"
      }), closeable && _react.default.createElement(_UIDialogCloseButton.default, {
        size: "lg",
        detached: true,
        onClick: onClose
      }), _react.default.createElement(StyledModalBody, null, _react.default.createElement(ImageComponent, {
        alt: imageAlt,
        objectFit: "contain",
        src: imageSrc
      })), _react.default.createElement(FooterWrapper, null, children && _react.default.createElement(FooterComponent, null, children)));
    }
  }]);
  return UILightbox;
}(_react.Component);

UILightbox.displayName = 'UILightbox';
UILightbox.propTypes = {
  children: _propTypes.default.node,
  closeable: _propTypes.default.bool.isRequired,
  FooterComponent: RenderProp.getPropType(_UIDialogFooter.default),
  ImageComponent: RenderProp.getPropType(_UIImage.default),
  imageAlt: _propTypes.default.string,
  imageSrc: _propTypes.default.string,
  onClose: _propTypes.default.func
};
UILightbox.defaultProps = {
  closeable: true,
  FooterComponent: DefaultFooterComponent,
  ImageComponent: LightboxImage
};
var _default = UILightbox;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/lightbox/UILightbox.js
// module id = 395
// module chunks = 209 210 211 212